module.exports = [
    'websiteType',
    'shortTitle',
    'language',
    'rights',
    'extra',
    'abstractNote',

     //Creator Types
     'contributor',
    
]


//////////////////
// WEBPACK FOOTER
// ./static/blacklists/mlaWebsite.js
// module id = 59f4
// module chunks = 1